/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmSkillsList } from "../../funcs/llmSkillsList.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListSkillsRequest$inboundSchema,
};

export const tool$llmSkillsList: ToolDefinition<typeof args> = {
  name: "llm-skills-list",
  description: `List skills

Returns a paginated list of skills.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmSkillsList(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
